import React from 'react'
import _ from 'lodash'

import {Collapse} from 'antd'

import {DeviceStore} from 'api/device'
import {ChannelsStorage} from 'storage'

const isConnected = ({meta}) => {
   const connected = meta['chan/connected'],
      disconnected = meta['chan/disconnected']

   if (connected && !disconnected) {
      return true
   } else if (connected > disconnected) {
      return true
   } else if (!connected) {
      return null
   }

   return false
}

const Channel = ({channel}) => {
   let connState,
      connClass = 'unknown',
      [nid, key] = _.first(channel.aliases, alias => alias.match(/\/@device\//))
         .replace(/.*\/@device\//, '')
         .split('/'),
      device = DeviceStore.device(nid, key)

   switch (isConnected(channel)) {
      case true:
         connState = 'Connected ' + channel.meta['chan/connected']
         connClass = 'connected'
         break

      case false:
         connState = 'Disconnected ' + channel.meta['chan/disconnected']
         connClass = 'disconnected'
         break

      case null:
         connState = 'Never Connected'
         break

      default:
         connState = 'Unknown Connection State'
   }

   const header = _.get(device, 'name', 'Unnamed Gateway') + ` — ${connState}`

   return (
      <Collapse.Panel key={channel.key} header={header} className={'square ' + connClass}>
         <p>
            Last input {_.get(channel, 'input.event/date')}<br />
            Queue Size {_.size(channel.queue)}
         </p>
      </Collapse.Panel>
   )
}

Channel.propTypes = {
   channel: React.PropTypes.object.isRequired
}

const Channels = ({channels}) => {
   return (
      <div className="types" style={{clear: 'both'}}>
         <div className="pager-header">
            <h2>Channels</h2>
         </div>

         <Collapse className="channels" bordered={false}>
            {_.map(channels, (chan, idx) => <Channel key={idx} channel={chan} />)}
         </Collapse>
      </div>
   )
}

Channels.propTypes = {
   network:  React.PropTypes.object.isRequired,
   channels: React.PropTypes.array
}

const deviceChan = ({aliases}) => _.any(aliases, alias => alias.match(/\/@device\//))

const WrappedTypes = ({network, ...rest}) =>
   network
      ? <ChannelsStorage nid={network.key} filter={deviceChan} {...rest}>
           <Channels network={network} />
        </ChannelsStorage>
      : <div>waiting for network</div>

WrappedTypes.propTypes = {
   network: React.PropTypes.object
}

export default WrappedTypes



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/overview/Channels.jsx